export default "__VITE_ASSET__DCToHROT__"